export default __webpack_public_path__ + "static/media/Brand-Favourite.3d7885ee.gif";